import { IPublicClientApplication } from '@azure/msal-browser';
import { MasterAwardRequest } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { createMasterAward, getMasterAwards, updateMasterAward } from './index';

export const createMasterAwardsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  createMasterAward: (instance: IPublicClientApplication, masterAward: MasterAwardRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createMasterAward(fetchContext, masterAward, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createMasterAward', isInFlight);
    },
  ),
  getMasterAwards: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getMasterAwards(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getMasterAwards', isInFlight);
    },
  ),
  updateMasterAward: (instance: IPublicClientApplication, masterAwardId: number, masterAward: MasterAwardRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateMasterAward(fetchContext, masterAwardId, masterAward, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateMasterAward', isInFlight);
    },
  ),
});
